"use client";

import { useState } from 'react';

export default function EnergyDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'CEO / CFO ENERGY DASHBOARD',
      subtitle: 'Executive Energy & Financial Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Energy Executive Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Grid Utilization', value: '87%', color: '#C5A572' },
            { x: 186, label: 'Energy Loss %', value: '3.2%', color: '#dc2626' },
            { x: 356, label: 'Daily Generation', value: '4,820 MWh', color: '#16a34a' },
            { x: 526, label: 'Operating Margin', value: '28.6%', color: '#16a34a' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Energy Generation vs Demand dual-axis */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Generation vs Demand (MWh)</text>
          <polyline points="40,285 80,268 120,272 160,255 200,260 240,242 280,248 320,232" fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" />
          <polyline points="40,278 80,275 120,265 160,268 200,252 240,258 280,240 320,244" fill="none" stroke="#C5A572" strokeWidth="2" strokeDasharray="5 3" strokeLinecap="round" />
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug'].map((m, i) => (
            <text key={i} x={40 + i * 40 - 6} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}
          <rect x="28" y="315" width="10" height="4" fill="#1B2845" rx="1" />
          <text x="42" y="319" fill="#374151" fontSize="8" fontFamily="sans-serif">Generation</text>
          <rect x="100" y="315" width="10" height="4" fill="#C5A572" rx="1" />
          <text x="114" y="319" fill="#374151" fontSize="8" fontFamily="sans-serif">Demand</text>

          {/* Revenue by Region */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Revenue by Region (₹ Cr)</text>
          {[
            { region: 'North Zone', val: 142, color: '#1B2845' },
            { region: 'South Zone', val: 118, color: '#C5A572' },
            { region: 'East Zone', val: 96, color: '#3b82f6' },
            { region: 'West Zone', val: 88, color: '#8b5cf6' },
          ].map((r, i) => (
            <g key={i}>
              <text x="370" y={172 + i * 30} fill="#374151" fontSize="9" fontFamily="sans-serif">{r.region}</text>
              <rect x="450" y={160 + i * 30} width={r.val * 1.4} height="16" fill={r.color} rx="2" opacity="0.8" />
              <text x={456 + r.val * 1.4} y={172 + i * 30} fill="#374151" fontSize="9" fontFamily="sans-serif">₹{r.val}Cr</text>
            </g>
          ))}

          {/* Demand Growth Forecast */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Demand Growth Forecast by Region</text>
          {[
            { region: 'North Zone', growth: '8.4%', color: '#16a34a' },
            { region: 'South Zone', growth: '6.2%', color: '#65a30d' },
            { region: 'East Zone', growth: '11.8%', color: '#C5A572' },
            { region: 'West Zone', growth: '5.1%', color: '#ca8a04' },
          ].map((f, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{f.region}</text>
              <rect x={28 + i * 168} y="364" width="140" height="12" fill="#f3f4f6" rx="3" />
              <rect x={28 + i * 168} y="364" width={parseFloat(f.growth) * 10} height="12" fill={f.color} rx="3" opacity="0.8" />
              <text x={28 + i * 168} y="392" fill={f.color} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{f.growth} growth</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'GRID OPERATIONS DASHBOARD',
      subtitle: 'Real-time Grid Performance & Outage Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Grid Operations Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Grid Load', value: '78%', color: '#C5A572' },
            { x: 186, label: 'Network Reliability', value: '99.2%', color: '#16a34a' },
            { x: 356, label: 'Active Outages', value: '2', color: '#dc2626' },
            { x: 526, label: 'Maintenance Alerts', value: '5', color: '#ca8a04' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="20" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Substation Performance Table */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Substation Performance</text>
          {[
            ['SS-01 North', '94%', '#16a34a'],
            ['SS-02 South', '88%', '#65a30d'],
            ['SS-03 East', '76%', '#ca8a04'],
            ['SS-04 West', '91%', '#16a34a'],
            ['SS-05 Central', '62%', '#ea580c'],
          ].map(([name, load, color], i) => (
            <g key={i}>
              <rect x="28" y={158 + i * 28} width="290" height="22" fill={i % 2 === 0 ? '#f9fafb' : 'white'} rx="3" />
              <text x="36" y={173 + i * 28} fill="#374151" fontSize="9" fontFamily="sans-serif">{name}</text>
              <rect x="200" y={162 + i * 28} width="80" height="10" fill="#f3f4f6" rx="3" />
              <rect x="200" y={162 + i * 28} width={parseFloat(load as string) * 0.8} height="10" fill={color as string} rx="3" opacity="0.75" />
              <text x="288" y={173 + i * 28} fill={color as string} fontSize="9" fontWeight="bold" fontFamily="sans-serif">{load}</text>
              <circle cx="300" cy={169 + i * 28} r="5" fill={color as string} opacity="0.8" />
            </g>
          ))}

          {/* Live Outage Alerts */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Live Outage Alerts</text>
          {[
            { area: 'Sector 12-B', severity: 'HIGH', customers: '2,840', color: '#dc2626', bg: '#fef2f2' },
            { area: 'Sector 7-A', severity: 'MEDIUM', customers: '1,120', color: '#ca8a04', bg: '#fefce8' },
            { area: 'Feeder F-22', severity: 'LOW', customers: '340', color: '#65a30d', bg: '#f0fdf4' },
          ].map((alert, i) => (
            <g key={i}>
              <rect x="370" y={158 + i * 44} width="302" height="36" fill={alert.bg} rx="5" />
              <text x="382" y={172 + i * 44} fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{alert.area}</text>
              <text x="382" y={186 + i * 44} fill="#6b7280" fontSize="8" fontFamily="sans-serif">{alert.customers} customers affected</text>
              <rect x="560" y={162 + i * 44} width="50" height="16" fill={alert.color} rx="3" opacity="0.15" />
              <text x="563" y={174 + i * 44} fill={alert.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{alert.severity}</text>
            </g>
          ))}

          {/* Maintenance Alert Cards */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Priority Maintenance Alerts</text>
          {[
            { asset: 'Transformer T-08', priority: 'P1', due: 'Today', color: '#dc2626' },
            { asset: 'Feeder Cable F-14', priority: 'P2', due: 'Mar 18', color: '#ca8a04' },
            { asset: 'Switchgear SG-03', priority: 'P3', due: 'Mar 25', color: '#65a30d' },
            { asset: 'Meter Bank MB-22', priority: 'P3', due: 'Apr 2', color: '#16a34a' },
          ].map((m, i) => (
            <g key={i}>
              <text x={28 + i * 168} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{m.asset}</text>
              <text x={28 + i * 168} y="372" fill="#6b7280" fontSize="8" fontFamily="sans-serif">Due: {m.due}</text>
              <rect x={28 + i * 168} y="378" width="40" height="16" fill={m.color} rx="3" opacity="0.15" />
              <text x={28 + i * 168 + 4} y="390" fill={m.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{m.priority}</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'CUSTOMER & CONSUMPTION ANALYTICS DASHBOARD',
      subtitle: 'Consumer Insights & Revenue Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Customer & Consumption Analytics</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Billing Accuracy', value: '97.8%', color: '#16a34a' },
            { x: 186, label: 'Theft Alerts', value: '14', color: '#dc2626' },
            { x: 356, label: 'Avg Consumption', value: '284 kWh', color: '#C5A572' },
            { x: 526, label: 'Peak Demand', value: '1,840 MW', color: '#1B2845' },
          ].map((kpi, i) => (
            <g key={i}>
              <rect x={kpi.x} y="56" width="158" height="60" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi.x + 12} y="74" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi.label}</text>
              <text x={kpi.x + 12} y="96" fill={kpi.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi.value}</text>
            </g>
          ))}

          {/* Peak Demand Chart with threshold */}
          <rect x="16" y="128" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Peak Demand (MW) — Hourly</text>
          <line x1="28" y1="220" x2="330" y2="220" stroke="#dc2626" strokeWidth="1" strokeDasharray="4 3" strokeOpacity="0.5" />
          <text x="295" y="218" fill="#dc2626" fontSize="7" fontFamily="sans-serif">Threshold</text>
          <polyline points="40,270 60,255 80,240 100,228 120,215 140,208 160,218 180,232 200,245 220,258 240,268 260,272 280,265 300,258 320,250" fill="none" stroke="#C5A572" strokeWidth="2.5" strokeLinecap="round" />
          <polyline points="40,270 60,255 80,240 100,228 120,215 140,208 160,218 180,232 200,245 220,258 240,268 260,272 280,265 300,258 320,250 320,295 40,295 Z" fill="#C5A572" opacity="0.08" />
          {['6am','8am','10am','12pm','2pm','4pm','6pm','8pm'].map((t, i) => (
            <text key={i} x={40 + i * 40 - 6} y="308" fill="#9ca3af" fontSize="7" fontFamily="sans-serif">{t}</text>
          ))}

          {/* Customer Segmentation Donut */}
          <rect x="358" y="128" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="148" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Customer Segmentation by Tier</text>
          <circle cx="480" cy="220" r="52" fill="none" stroke="#f3f4f6" strokeWidth="22" />
          <circle cx="480" cy="220" r="52" fill="none" stroke="#1B2845" strokeWidth="22" strokeDasharray="163 327" strokeDashoffset="0" />
          <circle cx="480" cy="220" r="52" fill="none" stroke="#C5A572" strokeWidth="22" strokeDasharray="98 327" strokeDashoffset="-163" />
          <circle cx="480" cy="220" r="52" fill="none" stroke="#3b82f6" strokeWidth="22" strokeDasharray="66 327" strokeDashoffset="-261" />
          <text x="480" y="216" textAnchor="middle" fill="#1B2845" fontSize="14" fontWeight="bold" fontFamily="sans-serif">1.2M</text>
          <text x="480" y="230" textAnchor="middle" fill="#6b7280" fontSize="8" fontFamily="sans-serif">Customers</text>
          <rect x="370" y="285" width="10" height="10" fill="#1B2845" rx="2" />
          <text x="384" y="294" fill="#374151" fontSize="8" fontFamily="sans-serif">Residential (50%)</text>
          <rect x="460" y="285" width="10" height="10" fill="#C5A572" rx="2" />
          <text x="474" y="294" fill="#374151" fontSize="8" fontFamily="sans-serif">Commercial (30%)</text>
          <rect x="560" y="285" width="10" height="10" fill="#3b82f6" rx="2" />
          <text x="574" y="294" fill="#374151" fontSize="8" fontFamily="sans-serif">Industrial (20%)</text>

          {/* Energy Theft Alert List */}
          <rect x="16" y="320" width="668" height="88" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="338" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Energy Theft Detection Alerts</text>
          {[
            { account: 'ACC-48291', zone: 'Zone 3-B', anomaly: '340% above baseline', status: 'INVESTIGATING', color: '#dc2626' },
            { account: 'ACC-71834', zone: 'Zone 1-A', anomaly: '280% above baseline', status: 'CONFIRMED', color: '#ea580c' },
            { account: 'ACC-22947', zone: 'Zone 5-C', anomaly: '190% above baseline', status: 'MONITORING', color: '#ca8a04' },
          ].map((alert, i) => (
            <g key={i}>
              <text x={28 + i * 224} y="358" fill="#374151" fontSize="9" fontWeight="bold" fontFamily="sans-serif">{alert.account}</text>
              <text x={28 + i * 224} y="370" fill="#6b7280" fontSize="8" fontFamily="sans-serif">{alert.zone} — {alert.anomaly}</text>
              <rect x={28 + i * 224} y="376" width="70" height="16" fill={alert.color} rx="3" opacity="0.12" />
              <text x={28 + i * 224 + 4} y="388" fill={alert.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{alert.status}</text>
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Utility Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">Purpose-built dashboards for every level of your energy organization.</p>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards.map((d, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300 ${
                activeTab === i
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/50'
              }`}
            >
              {d.title.split(' ').slice(0, 3).join(' ')}
            </button>
          ))}
        </div>

        {/* Dashboard Display */}
        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm">
          <div className="mb-6">
            <h3 className="font-serif text-navy text-2xl font-bold mb-1">{dashboards[activeTab].title}</h3>
            <p className="text-charcoal/60 text-sm">{dashboards[activeTab].subtitle}</p>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards[activeTab].svg}
          </div>
          <div className="flex gap-4 mt-6">
            <button className="px-6 py-2.5 bg-navy text-white text-sm font-semibold rounded-lg hover:bg-navy/90 transition-colors">View Demo</button>
            <button className="px-6 py-2.5 border border-gold text-gold text-sm font-semibold rounded-lg hover:bg-gold/5 transition-colors">Request Customization</button>
          </div>
        </div>
      </div>
    </section>
  );
}
